import { LocalShippingOutlined } from "@mui/icons-material";
import { IconButton, Stack, Tooltip, Zoom } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ChatInboxPopoverButton } from "components/ChatInboxPopoverButton";
import { CompanyProfileButton } from "components/CompanyProfileNavBarButton";
import { DataPageNavBarButton } from "components/DataPageNavBarButton";
import { NetworkButton } from "components/NetworkButton";
import { ShipmentTrackingSheetNavBarButton } from "components/Shipper/components/ShipmentTrackingSheetNavBarButton";
import { SupplierNetworkButton } from "components/SupplierNetwork/components/SupplierNetworkButton";

import { NavBarButtonWrapper } from "../NavBarButtonWrapper";
import { isCompanyRouteActive, isRouteActive, NAV_ROUTES } from "../routes";
import { AdminNavBarItems } from "./AdminNavBarItems";
import { NotificationsNavButton } from "./NotificationsNavButton";

interface ShipperNavBarItemsProps {
  pathName: string;
}

export function ShipperNavBarItems(props: ShipperNavBarItemsProps) {
  const { pathName } = props;
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" color="white" spacing={1}>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.DASHBOARD, true)}
      >
        <Tooltip title="Dashboard" placement="right" TransitionComponent={Zoom}>
          <IconButton
            color="inherit"
            onClick={() => navigate(NAV_ROUTES.DASHBOARD)}
          >
            <LocalShippingOutlined fontSize="large" />
          </IconButton>
        </Tooltip>
      </NavBarButtonWrapper>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.SHIPMENT_TRACKING)}
      >
        <ShipmentTrackingSheetNavBarButton />
      </NavBarButtonWrapper>
      <NotificationsNavButton />
      <NavBarButtonWrapper isActive={isRouteActive(pathName, NAV_ROUTES.CHAT)}>
        <ChatInboxPopoverButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.DATA_PAGE, true)}
      >
        <DataPageNavBarButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.NETWORK)}
      >
        <NetworkButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper
        isActive={isRouteActive(pathName, NAV_ROUTES.SUPPLIER_NETWORK)}
      >
        <SupplierNetworkButton />
      </NavBarButtonWrapper>
      <NavBarButtonWrapper isActive={isCompanyRouteActive(pathName, "profile")}>
        <CompanyProfileButton />
      </NavBarButtonWrapper>
      <AdminNavBarItems pathName={pathName} />
    </Stack>
  );
}
